import $ from "jquery";
import 'slick-carousel';
import 'jquery-waypoints/waypoints';

$(document).ready(function() {

	$('a.show--calendar-prev').addClass('disabled');
	$('span.show--calendar-month-name').text($('.show--calendar-month:first-child table').data('month'));

	$('.show--calendar-months').slick({
	  dots: false,
	  speed: 500,
	  arrows: false,
	  infinite: false,
	});

	if ($('#calendar-single').length) {

	  $('.show--calendar-purchase').on('click', 'a', function(e){
		if($(this).closest('div').hasClass('disabled')) {
		  e.preventDefault();
		}
	  });

	  $.getJSON( 'https://hkt.fi/wp-json/tickets/show/' + hkt_show.id + '/', function( response ) {

		var first_date = null;

		$.each( response, function( key, val ) {
		  if(val[1] == 0) {
			$('#calendar-single td.this-month[data-date="' + val[0] + '"]').addClass('events events-full');
		  } else {
			$('#calendar-single td.this-month[data-date="' + val[0] + '"]').addClass('events');
			if(first_date === null) {
			  first_date = val[0];
			}
		  }
		});

  		console.log(first_date);

		if(first_date) {

		  // Valitse ensimmäinen
		  $('#calendar-single td.this-month[data-date="' + first_date + '"]').trigger('click');

		  var firstSlickIndex = $('#calendar-single td.this-month[data-date="' + first_date + '"]').closest('.slick-slide').data('slick-index');
		  $('.show--calendar-months').slick('slickGoTo',firstSlickIndex);

		  console.log(firstSlickIndex);

		  $('.hero--buy').css('visibility','visible').hide().fadeIn('slow');

		} else {

		  // Kaikki esitykset on myyty loppuun
		  $('.show--calendar-purchase-buy-tickets').html('<span class="all-sold-out">' + lillan_translations['All shows have been sold-out.'] + '</span>');
		  $('.show--calendar-purchase-order-serving').html('');

		  $('.show--buy-secondary').html('<strong class="all-sold-out" style="color: #2bb976">' + lillan_translations['All shows have been sold-out.'] + '</strong>');
		  $('.hero--buy').html('');

		}

	  });

	  $('#calendar-single').on('click', 'td.events', function(e){
		e.preventDefault();

		$('.show--calendar-purchase-buy-tickets, .show--calendar-purchase-order-serving').addClass('state-disabled');

		$('.show--calendar-purchase a span').addClass('state-hidden');

		$('.show--calendar-purchase-buy-tickets').append('<div class="show--calendar-purchase--loader"></div>');

		$('#calendar-single em.state--selected').each(function( index ) {
		  $(this).closest('span').html($(this).closest('span').text());
		});

		$(this).find('span').wrapInner('<em class="state--selected"></em>');

		var events_full = $(this).hasClass('events-full');

		$.getJSON( 'https://hkt.fi/wp-json/tickets/show/' + hkt_show.id + '/' + $(this).data('date') + '/', function( response ) {

		  if(response.length > 0 ) {

			$('.show--calendar-purchase-buy-tickets').html('');
			$('.show--calendar-purchase-order-serving').html('');

			if( events_full ) {
			  $('.show--calendar-purchase-order-serving').removeClass('state-disabled');
			} else {
			  $('.show--calendar-purchase-buy-tickets, .show--calendar-purchase-order-serving').removeClass('state-disabled');
			}

			for(var i=0;i<response.length;i++) {

			  if( events_full ) {
				$('.show--calendar-purchase-buy-tickets').html('<a href="#" class="sold-out"><span class="state-hidden">' + lillan_translations['Sold-out'] + '</span></a>');
			  } else {

				if(response[i]['availability'] === '1') {
				  $('.show--calendar-purchase-buy-tickets').append('<a href="' + response[i]['url'] + '" target="_blank"><span class="state-hidden">' + lillan_translations['Buy tickets'] + ' ' + response[i]['date'] + ' ' + response[i]['time'] + '</span></a>');
				} else {
				  //$('.show--calendar-purchase-buy-tickets').append('<a href="#" class="sold-out"><span class="state-hidden">' + response[i]['date'] + ' ' + response[i]['time'] + ' ' + lillan_translations['Sold-out'] + '</span></a>');
				}

				if(response[i]['event_name'].indexOf('K18') !== -1 || response[i]['event_name'].indexOf('K-18') !== -1) {
				  $('.show--calendar-purchase-buy-tickets').append('<span class="age-restrictions">' + lillan_translations['Minimum age 18+'] + '</span>');
				}
			  }

			  var order_link = null;
			  var order_response_id = null;

				order_response_id = response[i]['event_id'];
				if(order_response_id.indexOf('tm-') !== -1) {
				  order_response_id = order_response_id.replace('tm-', '');
				}

				order_link = 'http://shop.sodexo.fi/hkt/' + order_response_id + '/';

				// NOTE: Disabled the 'Order serving / Tilaa tarjoilut' functionality here, will add if the client requests it
				//$('.show--calendar-purchase-order-serving').append('<a href="' + order_link + '" target="_blank"><span class="state-hidden">' + lillan_translations['Order serving'] + ' ' + response[i]['date'] + ' ' + response[i]['time'] + '</span></a>');

			}

		  } else {

			$('.show--calendar-purchase-buy-tickets').html('<a href="#"><span class="state-hidden">' + lillan_translations['Buy tickets'] + '</span></a>');
			$('.show--calendar-purchase-order-serving').html('<a href="#"><span class="state-hidden">' + lillan_translations['Order serving'] + '</span></a>');

		  }

		}).complete(function() {

		  $('.show--calendar-purchase-buy-tickets .show--calendar-purchase--loader').remove();

		  setTimeout(function(){
			$('.show--calendar-purchase a span').removeClass('state-hidden');
		  }, 100);

		  if($('.show-calendar--widget.active-state').length) {

			var number_of_shows_left = $('td.events').length;
			number_of_shows_left = parseInt(number_of_shows_left);

			if(number_of_shows_left < 6) {
			  $('.show--calendar-purchase-buy-tickets').after('<span class="coming-to-a-close">' + lillan_translations['Attention! The show is coming to a close.'] + '</span>');
			}

		  }

		});

	  });

	}

	/* */

	$('.show--calendar-months').on('afterChange', function(event, slick, currentSlide){
	  var month = $(this).find('.show--calendar-month:eq(' + currentSlide + ')').find('table').data('month');
	  $('span.show--calendar-month-name').text(month);

	  $('.show--calendar-controls a').removeClass('disabled');

	  if(currentSlide === 0) {
		$('a.show--calendar-prev').addClass('disabled');
	  }

	  if((currentSlide+1) === $('.show--calendar-month').length) {
		$('a.show--calendar-next').addClass('disabled');
	  }

	  //$('.show--calendar').removeClass('init');

	});

	$('.show--calendar-controls a').click(function(e) {
      e.preventDefault();

      if($(this).hasClass('show--calendar-prev')) {
        $('.show--calendar-months').slick('slickPrev');
      } else {
        $('.show--calendar-months').slick('slickNext');
      }
    });

});
